export enum ViewActionType {
  DISABLE = 'DISABLE',
  SHOW = 'SHOW'
}

export interface IViewControlChangedEvent {
  viewAction: ViewActionType;
  result: boolean;
}
